<div class="slider" #sliderContainer>
  <ul
    #slider
    b2cSwipe
    tabindex="0"
    id="rewards"
    class="slider-inner"
    (swipeStart)="panStart()"
    (swipeEnd)="panEnd($event)"
    (swipeMove)="panMove($event)"
    (keydown)="handleKeydown($event)"
  >
    @if (itemType() === SliderItemType.CHALLENGE) {
      @for (challenge of challenges(); track challenge.offerId) {
        @if ([OfferType.STEP, OfferType.FREQUENCY].includes(challenge.type)) {
          <div class="item challenge-item" data-cy="bis_challenge">
            @switch (challenge.type) {
              @case (OfferType.STEP) {
                <b2c-step-challenge
                  [index]="$index"
                  [withShadow]="false"
                  [isBisCampaign]="true"
                  [isEventChallenge]="false"
                  [phase]="CampaignPhase.CURRENT"
                  [loadBannerInPriority]="$index < 10"
                  [challenge]="challenge"
                />
              }
              @case (OfferType.FREQUENCY) {
                <b2c-frequency-challenge
                  [withShadow]="false"
                  [isBisCampaign]="true"
                  [isEventChallenge]="false"
                  [phase]="CampaignPhase.CURRENT"
                  [challenge]="challenge"
                />
              }
            }
          </div>
        }
      }
    } @else if (itemType() === SliderItemType.REWARD) {
      @for (reward of rewards(); track reward.rewardId) {
        <b2c-reward
          data-cy="reward"
          [reward]="reward"
          animate.enter="fade-in"
          animate.leave="fade-out"
          class="item reward-item"
        />
      }
    }
  </ul>
</div>
